import { createContext, useContext } from 'react';

/**
 * Context used to track a map of viewports used to persist viewport changes when scrolling data table
 * rendering path visualizations. This is needed as we use virtualized rendering to re-render items as a
 * user scrolls on a table, resulting in all viewport pan and zoom changes getting reset whenever a path
 * chart is scrolled out of view. This creates an annoying UX where user has to re-zoom and re-pan every
 * time they scroll away from a path visualization when doing path comparisons in the list.
 */
export const pathChartTableViewportsContext = createContext();

export const PathChartTableViewportsProvider = pathChartTableViewportsContext.Provider;

export const usePathChartTableViewports = () => useContext(pathChartTableViewportsContext);
